import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import "./style.scss";
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch } from "react-redux";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { wrongIcon } from "../../utils/images";
import { cancelRequestRequest } from "../../store/requests/actions";
import { useSelector } from "react-redux";

const CancelForm = ({ intl: { messages }, show, close, selectedRequest }) => {
     const lang = localStorage.getItem("lang") || "en";
     const dispatch = useDispatch();
     const { canceledRequest } = useSelector(state => state.requests)
     const [feedBack, setFeedBack] = useState(null);
     const [showConfirmation, setShowConfirmation] = useState(false);
     const [formData, setFormData] = useState({
        id: selectedRequest,
        message: '',
     });

    const clear = () => {
        setFormData({
            id: selectedRequest,
            message: '',
        });
        setFeedBack(null);
    }

    useEffect(() => {
        if (selectedRequest) {
            setFormData({
                ...formData,
                id: selectedRequest
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRequest])

     //Clear and close
     useEffect(() => {
        if (canceledRequest) {
            clear();
            close();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canceledRequest]);


    const save = () => {
        dispatch(cancelRequestRequest(formData))
    }

    return (
        <div className={`test-modal_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="test-modal_container_content">
                    <CancelIcon onClick={close} className="test-modal_container_content_close" />
                <div className="test-modal_container_content_header">
                    <img src={wrongIcon} alt="wrongIcon" />
                    <h4>{messages.appointments.cancel_title}</h4>
                </div>
                <div className="test-modal_container_content_body">
                    <form>
                        <label htmlFor="code" style={{marginBottom: "10px", marginTop: "15px"}} >{messages.appointments.request_status} : <span>{messages.appointments.medical_interview}</span></label>
                        <label htmlFor="canceling_reason" style={{marginBottom: "10px"}} >{messages.appointments.canceling_reason}</label>
                        <textarea
                            id='canceling_reason'
                            name="canceling_reason"
                            placeholder={messages.appointments.canceling_reason_placeholder}
                            value={formData.notes}
                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                            rows={3}
                            ></textarea>
                        <div className="actions">
                                <button className="cancel" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        close();
                                        }}>
                                        {messages.patients.form.btn_cancel}                           
                                </button>
                                <button onClick={(e) =>  {
                                    e.preventDefault();
                                    save();
                                    }} >
                                    {messages.patients.form.btn_save}
                                </button>
                        </div>
                        <p id="feedback"><span style={{ background: '#FFF' }}>{feedBack}</span></p>
                    </form>   
                </div>
            </div>
            <ConfirmDialog show={showConfirmation} 
                     onCancel={() => setShowConfirmation(false)}
                     onConfirm={() => {
                        setShowConfirmation(false);
                        clear();
                        close();
                     }}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}
export default injectIntl(CancelForm);
